/** @jsx jsx */

import type { ReactNode } from 'react';
import { jsx } from '@balance-web/core';
import { buildDataAttributes } from '@balance-web/core';
import type { WithDataAttributeProp } from '@balance-web/core';

export type EmphasizedProps = WithDataAttributeProp<{
  children: ReactNode;
  id?: string;
}>;

export const Emphasized = ({ children, id, data }: EmphasizedProps) => {
  const dataAttributes = buildDataAttributes(data);

  return (
    <strong css={{ fontStyle: 'italic' }} id={id} {...dataAttributes}>
      {children}
    </strong>
  );
};
